module.exports = __webpack_public_path__ + "static/media/leftBar.e657b63f.png";